export const IconFollower = ({ size = 24 }) => (
	<svg
		width={size}
		height={size}
		viewBox={`0 0 ${size} ${size}`}
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g transform={`scale(${size / 24})`}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.52629 4.89473C6.12822 4.89473 4.1842 6.83875 4.1842 9.23682C4.1842 11.6349 6.12822 13.5789 8.52629 13.5789C10.9244 13.5789 12.8684 11.6349 12.8684 9.23682C12.8684 6.83875 10.9244 4.89473 8.52629 4.89473ZM5.92104 9.23682C5.92104 7.79797 7.08745 6.63156 8.52629 6.63156C9.96513 6.63156 11.1315 7.79797 11.1315 9.23682C11.1315 10.6757 9.96513 11.8421 8.52629 11.8421C7.08745 11.8421 5.92104 10.6757 5.92104 9.23682Z"
				fill="currentColor"
			/>
			<path
				d="M1 20.1315C1 16.9922 3.5449 14.4473 6.68419 14.4473H10.3684C13.5077 14.4473 16.0526 16.9922 16.0526 20.1315V20.4473C16.0526 20.9705 15.6284 21.3947 15.1052 21.3947C14.582 21.3947 14.1578 20.9705 14.1578 20.4473V20.1315C14.1578 18.0387 12.4613 16.3421 10.3684 16.3421H6.68419C4.59133 16.3421 2.89473 18.0387 2.89473 20.1315V20.4473C2.89473 20.9705 2.47058 21.3947 1.94737 21.3947C1.42415 21.3947 1 20.9705 1 20.4473V20.1315Z"
				fill="currentColor"
			/>
			<path
				d="M13.4061 4.75667C13.8838 4.13493 14.632 3.73684 15.4736 3.73684C16.9125 3.73684 18.0789 4.90325 18.0789 6.34209C18.0789 7.78093 16.9125 8.94734 15.4736 8.94734C15.3696 8.94734 15.2672 8.94129 15.167 8.92957C14.6906 8.87392 14.2593 9.21499 14.2037 9.69136C14.148 10.1677 14.4891 10.599 14.9655 10.6547C15.1325 10.6742 15.3021 10.6842 15.4736 10.6842C17.8717 10.6842 19.8157 8.74016 19.8157 6.34209C19.8157 3.94402 17.8717 2 15.4736 2C14.0696 2 12.8211 2.6673 12.0288 3.69847C11.7366 4.07878 11.808 4.62397 12.1884 4.91619C12.5687 5.2084 13.1139 5.13699 13.4061 4.75667Z"
				fill="currentColor"
			/>
			<path
				d="M14.8946 12.1315L17.3158 12.1315C20.4551 12.1315 23 14.6764 23 17.8157V18.1315C23 18.6547 22.5758 19.0789 22.0526 19.0789C21.5294 19.0789 21.1053 18.6547 21.1053 18.1315V17.8157C21.1053 15.7229 19.4087 14.0263 17.3158 14.0263H14.8946C13.1579 14.0263 13.1579 12.1315 14.8946 12.1315Z"
				fill="currentColor"
			/>
		</g>
	</svg>
);
